module.exports = __webpack_public_path__ + "static/Pediatrics-1dfa9f0cb83d9c8cad91ac3eccbb2a7f.png";